import { createApp } from "vue";
import App from "./App.vue";
import "./assets/style/main.scss";

createApp(App).mount("#app");
